/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpdateSubjectCommentRequest } from '../models/UpdateSubjectCommentRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SubjectCommentRestControllerService {
  /**
   * updateSubjectComments
   * @returns any OK
   * @throws ApiError
   */
  public static updateSubjectCommentsUsingPut({
    request,
  }: {
    /**
     * request
     */
    request: UpdateSubjectCommentRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/subject-comments',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
